import { axios, APIBASE_REVIVERUSERS, APIBASE_REVIVERCONTRACTS } from "./ApiConfig";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { ContractDeviationType, ContractDeviationUnit } from "@/types";
import { ContractDeviationFormInput } from "@/components/pages/Settings/validation/contractDeviationValidationSchema";

const getContractDeviationTypes = async (companyId: number, includeDisabled: boolean) =>
  axios.get(
    `${APIBASE_REVIVERUSERS}api/company/settings/contractDeviationTypes/${companyId}?includeDisabled=${includeDisabled}`
  );

export const useGetContractDeviationTypes = (
  companyId: number,
  includeDisabled: boolean,
  options?: Partial<UseQueryOptions<ContractDeviationType[]>>
) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<ContractDeviationType[]>({
    queryKey: ["contractDeviationTypes", companyId, includeDisabled],
    queryFn: async () => {
      const result = await getContractDeviationTypes(companyId, includeDisabled);
      return result.data;
    },
    ...queryOptions,
  });
};

export const createContractDeviationType = async (deviation: ContractDeviationFormInput) =>
  axios.post(`${APIBASE_REVIVERUSERS}api/company/settings/contractDeviationTypes`, deviation);

export const updateContractDeviationType = async (deviationId: number, deviation: ContractDeviationFormInput) =>
  axios.put(`${APIBASE_REVIVERUSERS}api/company/settings/contractDeviationTypes/${deviationId}`, deviation);

export const deactivateContractDeviationType = async (deviationId: number) =>
  axios.post(`${APIBASE_REVIVERUSERS}api/company/settings/contractDeviationTypes/${deviationId}/disable`);

const getContractDeviationUnits = async () => axios.get(`${APIBASE_REVIVERCONTRACTS}api/contracts/deviations/units`);

export const useGetContractDeviationUnits = (options?: any) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<ContractDeviationUnit[] | undefined>({
    queryKey: ["contractDeviationUnits"],
    queryFn: async () => {
      const result = await getContractDeviationUnits();
      return result.data;
    },
    ...queryOptions,
  });
};

const getContractDeviationTypeById = async (deviationTypeId: number) =>
  axios.get(`${APIBASE_REVIVERUSERS}api/company/settings/contractDeviationType/${deviationTypeId}`);

export const useGetContractDeviationTypeById = (
  deviationTypeId: number,
  options?: Partial<UseQueryOptions<ContractDeviationType>>
) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<ContractDeviationType>({
    queryKey: ["contractDeviationType", deviationTypeId],
    queryFn: async () => {
      const result = await getContractDeviationTypeById(deviationTypeId);
      return result.data;
    },
    ...queryOptions,
  });
};
